export const saveFile = (blob, filename) => {
    // @ts-ignore
    if (window.navigator.msSaveOrOpenBlob) {
        // @ts-ignore
        window.navigator.msSaveOrOpenBlob(blob, filename);
    }
    else {
        const a = document.createElement('a');
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        setTimeout(() => {
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }, 0);
    }
};
export const download = (authToken, link, filename) => {
    return fetch(link, {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    })
        .then((response) => {
        if (!response.ok) {
            throw new Error('File failed to download');
        }
        return response.blob();
    })
        .then((blob) => {
        return saveFile(blob, filename);
    });
};
//# sourceMappingURL=utils.js.map